/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_LoadingInputs */

const vi_invoice_misa_template_loading = /** @type {(inputs: Invoice_Misa_Template_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải mẫu hóa đơn từ MISA...`)
};

/**

* @param {Invoice_Misa_Template_LoadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_loading = /** @type {((inputs?: Invoice_Misa_Template_LoadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_LoadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_loading(inputs)
});